module.exports = __webpack_public_path__ + "static/footer-particle-two-e9424e6dcbdc77e2d9d999fd6b28c94f.png";